// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3qPIo","content":"RecentSearches_content__3D_S0"};